import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { TemplateSubTab } from '@/types/admin.types';
import type { BuilderState } from '@/types/survey.types';
import { CatalogSubTab } from './CatalogSubTab';
import { TipsSubTab } from './TipsSubTab';
import { AccionesSubTab } from './AccionesSubTab';
import { CatalogoSubTab } from './CatalogoSubTab';
import { OUsSubTab } from './OUsSubTab';

interface TemplatesTabProps {
  onOpenBuilder: (state: BuilderState) => void;
}

export function TemplatesTab({ onOpenBuilder }: TemplatesTabProps) {
  const { t } = useTranslation();
  const [sub, setSub] = useState<TemplateSubTab>('catalog');

  const subTabs: Array<{ id: TemplateSubTab; icon: string; labelKey: string }> = [
    { id: 'catalog',       icon: 'fa-layer-group', labelKey: 'admin.templates'  },
    { id: 'tips',          icon: 'fa-lightbulb',   labelKey: 'admin.tipsTab'    },
    { id: 'acciones',      icon: 'fa-rocket',      labelKey: 'admin.actionsTab' },
    { id: 'fundamentales', icon: 'fa-cubes',       labelKey: 'admin.catalogTab' },
    { id: 'ous',           icon: 'fa-sitemap',     labelKey: 'admin.ousTab'     },
  ];

  return (
    <div className="adm-tab-content">
      <div className="tpl-subnav">
        {subTabs.map(st => (
          <button
            key={st.id}
            className={`tpl-subnav-btn${sub === st.id ? ' tpl-subnav-active' : ''}`}
            onClick={() => setSub(st.id)}
          >
            <i className={`fas ${st.icon}`} /> {t(st.labelKey)}
          </button>
        ))}
      </div>

      {sub === 'catalog'       && <CatalogSubTab onOpenBuilder={onOpenBuilder} />}
      {sub === 'tips'          && <TipsSubTab />}
      {sub === 'acciones'      && <AccionesSubTab />}
      {sub === 'fundamentales' && <CatalogoSubTab />}
      {sub === 'ous'           && <OUsSubTab />}
    </div>
  );
}
